import * as React from 'react';
import {
    Controller,
    Toolbar,
    MainMenu,
    ActionPointInfo,
    IActionPointInfo,
    Menu,
    CustomArgs,
} from '@tencent/workbench';
import { ToggleFeature } from '@framework/workbench/ui/toggle/toggle-feature';
import {
    TOOLBAR_ITEMS,
    MENU_CONFIG,
    config,
    IMMERSIVE_TOGGLE,
} from './config';
import { ToolbarType } from '@src/js/constant';
import { TDWModuleType, EventCodeType, TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

/**
 * 切换单双栏，切换沉浸模式
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIG,
})
export class ToggleController {
    constructor(private readonly feature: ToggleFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    public insertDropdown() {
        return <MainMenu
            align="left"
            name={config.id}
            mode="menu"
            itemStyle={{ width: 156 }}
        />;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        if (!visible) return;
        this.feature.tdwReport({
            module: TDWModuleType.TOOLBAR_MODE,
            action: TDWActionType.TOOLBAR_OPEN,
            eventcode: EventCodeType.WORKBENCH_TOGGLE_OPEN_EVENT_OPEN,
        });
    }

    /**
     * 简约工具栏模式时，隐藏工具栏切换入口
     * @returns
     */
    @Toolbar(config.id, 'shouldHide')
    public shouldHide() {
        return this.feature.shouldHideToolbarMode();
    }

    @Menu(ToolbarType.SINGLE_TOOLBAR, 'onClick', { mode: ToolbarType.SINGLE_TOOLBAR })
    @Menu(ToolbarType.DOUBLE_TOOLBAR, 'onClick', { mode: ToolbarType.DOUBLE_TOOLBAR })
    public changeMode(@CustomArgs() args: { mode: string }) {
        const { mode } = args;
        this.feature.setToolbarMode(mode);
    }

    @Menu(ToolbarType.SINGLE_TOOLBAR, 'shouldCheck')
    @Menu(ToolbarType.DOUBLE_TOOLBAR, 'shouldCheck')
    @Menu(IMMERSIVE_TOGGLE, 'shouldCheck')
    public shouldCheck(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        const toolbarMode = this.feature.getToolbarMode();
        return toolbarMode === name;
    }

    @Menu(IMMERSIVE_TOGGLE, 'onClick')
    public hideMenu() {
        this.feature.hideMenu();
    }
}
